import type { MyPushDto, PushPrefs, SubscribePushBody } from '@malash-office/types';
import instanceAxios from '@/util/axios';

/** התראות בטלפון — the caller's own phones (`/pvt/me/push`, docs/product-planning/PWA-PUSH.md). */

const ME = 'pvt/me/push';

export const getMyPush = async (): Promise<MyPushDto> => (await instanceAxios.get<MyPushDto>(ME)).data;

export const getPushPublicKey = async (): Promise<string> =>
  (await instanceAxios.get<{ publicKey: string }>(`${ME}/public-key`)).data.publicKey;

export const subscribeMyPush = async (body: SubscribePushBody): Promise<MyPushDto> =>
  (await instanceAxios.post<MyPushDto>(`${ME}/subscribe`, body)).data;

/**
 * Sent on sign-out, after the token has already been cleared from storage — so the token is passed
 * in and set explicitly rather than read by the interceptor.
 */
export const unsubscribeMyPush = async (endpoint: string, token: string): Promise<{ removed: boolean }> =>
  (await instanceAxios.post<{ removed: boolean }>(`${ME}/unsubscribe`, { endpoint }, { headers: { Authorization: token } }))
    .data;

export const removeMyPushDevice = async (id: number): Promise<MyPushDto> =>
  (await instanceAxios.delete<MyPushDto>(`${ME}/${id}`)).data;

export const sendMyPushTest = async (): Promise<{ deliveredCount: number; failedCount: number }> =>
  (await instanceAxios.post<{ deliveredCount: number; failedCount: number }>(`${ME}/test`)).data;

export const updateMyPushPrefs = async (patch: Partial<PushPrefs>): Promise<MyPushDto> =>
  (await instanceAxios.patch<MyPushDto>(`${ME}/prefs`, patch)).data;
